module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "mattertitle"
  }, [_c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("First, I want to thank Suzanne Richardson, an extremely bright and capable young woman who worked as my assistant on this book. Suzanne did a good deal of the research and all of the interviews.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("None of my writing would be readable were it not for the intelligent edifications of Judith Strauss. Judith has been my editor longer than either of us would care to admit. I wouldn’t feel comfortable publishing anything that hadn’t been trimmed and polished by her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I want to say special thank yous to Charlie Byrne, editorial director of my e-zine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Early to Rise")]), _vm._v(", and Steve Sjuggerud, editor of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("True Wealth")]), _vm._v(", whose insightful and experienced comments helped me identify which, of the many ideas I initially wrote down, were important and worth keeping. Thanks also to Dave Lashmet and Gary Lundberg, whose financial expertise was invaluable in reviewing, correcting, and updating the financial planning portions of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The folks in Agora Inc.’s book publishing department—Michael Ward, Wayne Ellis, and Danielle Morino—were, as usual, extraordinarily patient and helpful in working with the John Wiley team. In particular, I’d like to thank Joan O’Neil, my publisher, for her faith in the book and willingness to make last-minute changes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And, finally, my admiration and gratitude go out to all of those people who inspired this book and whose wealth-building ideas, strategies, and techniques deepened and extended my own: Audrey Maxwell, Alan Silver, Bruce Buffer, Justin Ford, Ken Morris, Monica Day, David Keller, and Brad Solomon, I thank you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be8c8cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Acknowledgments.vue
// module id = 66
// module chunks = 0